var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGitlab = function SvgGitlab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "m13.8 32.71 5.08-15.638H8.719l5.081 15.638Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "M13.8 32.71 8.718 17.072H1.597L13.799 32.71Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "M1.596 17.072.052 21.824c-.141.434.013.909.382 1.176l13.365 9.71L1.596 17.072Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M1.597 17.072h7.121l-3.06-9.418a.526.526 0 0 0-1 0l-3.061 9.418Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "m13.8 32.71 5.082-15.638h7.122L13.8 32.71Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "m26.004 17.072 1.544 4.752c.14.434-.014.909-.382 1.176L13.8 32.71l12.203-15.638Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M26.002 17.072h-7.121l3.06-9.418a.526.526 0 0 1 1 0l3.061 9.418Z"
  })));
};
export default SvgGitlab;